import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { StorageService } from 'src/app/shared/services/storage.service';
import { QrObra } from '../../models/qr-obra.model';
import { QrObrasService } from '../../services/qr-obra-service';

@Component({
  selector: 'app-pesquisa-geral-obras',
  templateUrl: './pesquisa-geral-obras.component.html',
  styleUrls: ['./pesquisa-geral-obras.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-50%)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateX(-50%)' }))
      ])
    ])
  ],
})
export class PesquisaGeralObrasComponent extends BaseListComponent<any> implements OnInit {

  form: FormGroup;
  filters: any;
  obrasList: QrObra[];
  filterActive: boolean = false;

  constructor(
    private router: Router,
    public activatedRoute: ActivatedRoute,
    public qrObrasService: QrObrasService,
    private storageService: StorageService,
  ) {
    super();
  }

  ngOnInit() {
    this.filters = this.activatedRoute.snapshot.data["filters"];
    this.initForm();
    this.search();
  }

  initForm() {
    this.form = new FormGroup({
      filter_status: new FormControl(null),
      filter_agency: new FormControl(null),
      filter_city: new FormControl(null),
      filter_main_manager: new FormControl(null),
      filter_project_full_id: new FormControl(null),
    })
    let filterValue = this.storageService.getFilterValue('filterObrasValue');
    if (filterValue) {
      this.filterActive = true;
      this.form.patchValue(filterValue);
    }
  }

  cleanSearch() {
    this.storageService.removeFilterValue('filterObrasValue');
    this.form.reset();
  }

  closeFilter() {
    if (this.filterActive) {
      this.filterActive = false;
    }
  }

  getDataCreate(filterSave = false) {
    let data: any;
    data = Object.assign({}, data, this.form.value);
    if (filterSave && !Object.values(data).every(value => value === null)) {
      this.storageService.setFilterValue('filterObrasValue', data);
    }
    return data;
  }

  search(filterSave = false) {
    this.loading();
    this.addSub(
      this.qrObrasService.getListSearch(this.getDataCreate(filterSave)).subscribe({
        next: (res) => {
          this.obrasList = res;
          this.loaded();
        },
      })
    );
  }
}
